<script>
  import { createEventDispatcher } from "svelte";
  import axios from "axios";
  import { onMount } from "svelte";
  import { getHost } from "../../utils/sendwhatsapp_rewrite_chabi";
  import { currentLanguage } from "../../store";
  import translations from "../../translations";
  import BookingQuantitySummary from "./BookingQuantitySummary.svelte";

  export let bookingConfig;
  export let data;
  export let quantity;
  export let autoShowTimes = false;
  export let availabilityEnabled = true;
  export let showQuantitySummary = true;
  export let initialDate = null;

  const dispatch = createEventDispatcher();

  const date = new Date();
  const apiUrl = getHost();

  const today = {
    dayNumber: date.getDate(),
    month: date.getMonth(),
    year: date.getFullYear(),
  };

  let currentLang = navigator.language.split("-")[0] || "en"; // Default language

  const parsedInitialDate = /^\d{4}-\d{2}-\d{2}$/.test(initialDate || "")
    ? new Date(`${initialDate}T00:00:00`)
    : null;
  let monthIndex = parsedInitialDate && !Number.isNaN(parsedInitialDate.getTime()) ? parsedInitialDate.getMonth() : date.getMonth();

  let monthStore = [];

  let availableStore = [];

  let year = parsedInitialDate && !Number.isNaN(parsedInitialDate.getTime()) ? parsedInitialDate.getFullYear() : date.getFullYear();

  $: firstDayIndex = new Date(year, monthIndex, 1).getDay();

  $: firstDayIndexCal = firstDayIndex === 0 ? 7 : firstDayIndex;

  $: numberOfDays = new Date(year, monthIndex + 1, 0).getDate();

  $: calendarCellsQty = (firstDayIndex > 0 && firstDayIndex <= 5) || (firstDayIndex === 6 && numberOfDays <= 30) ? 35 : 42;

  $: selected = 0;

  $: fetchMonthsCount = 8;

  onMount(async () => {
    if (!availabilityEnabled) {
      fetchMonthsCount = 0;
      if (autoShowTimes) showEmptyScheduler();
      return;
    }

    if (parsedInitialDate && !Number.isNaN(parsedInitialDate.getTime())) {
      await fetchBookingDays();
      fetchMonthsCount = 0;
      await fetchBookingTimes(parsedInitialDate.getDate());
      return;
    }

    if (autoShowTimes) {
      await loadVisibleMonth();
      fetchMonthsCount = 0;
      return;
    }

    while (fetchMonthsCount > 0) {
      await fetchBookingDays();
      if (monthStore.length > 0) {
        fetchMonthsCount = 0;
        break;
      }
      if (monthIndex >= 11) {
        year += 1;
        monthIndex = 0;
      } else {
        monthIndex += 1;
      }
      fetchMonthsCount--;
    }
    if (monthStore.length === 0) {
      monthIndex = date.getMonth();
      year = date.getFullYear();
    }
  });

  let formatter = new Intl.DateTimeFormat(navigator.language, { weekday: "short", timeZone: "UTC" });
  const days = [2, 3, 4, 5, 6, 7, 1].map((day) => {
    const dd = day < 10 ? `0${day}` : day;
    return new Date(`2017-01-${dd}T00:00:00+00:00`);
  });

  const daysList = days.map((date) => formatter.format(date));

  formatter = new Intl.DateTimeFormat(navigator.language, { month: "long", timeZone: "UTC" });

  const months = Array.from({ length: 12 }, (_, i) => i + 1).map((month) => {
    const mm = month < 10 ? `0${month}` : month;
    return new Date(`2017-${mm}-01T00:00:00+00:00`);
  });

  const monthList = months.map((date) => formatter.format(date));

  $: month = monthList[monthIndex];

  const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

  const fetchBookingDays = async () => {
    const quantityParam = quantity !== undefined ? `&quantity=${encodeURIComponent(quantity)}` : "";
    await axios
      .get(
        `${apiUrl}/api/booking/${
          bookingConfig.id ?? 2 //for test
        }/calendar?type=month&date=${year}-${monthIndex + 1}${quantityParam}`
      )
      .then((response) => {
        const bookableDays = response.data
          .filter((item) => item.bookable)
          .sort((a, b) => parseInt(a.day.split("-")[2]) - parseInt(b.day.split("-")[2]));
        monthStore = bookableDays.map((item) => parseInt(item.day.split("-")[2]));
        availableStore = bookableDays.map((item) => item.numberOfAvailableSlots);
        console.log("fetchBookingDays", monthIndex + 1, availableStore, monthStore);
      })
      .catch((error) => {
        //console.log('error', error)
      });
  };

  const fetchBookingTimes = async (dayNumber) => {
    const quantityParam = quantity !== undefined ? `&quantity=${encodeURIComponent(quantity)}` : "";
    await axios
      .get(`${apiUrl}/api/booking/${bookingConfig.id}/calendar?type=day&date=${year}-${monthIndex + 1}-${dayNumber}${quantityParam}`)
      .then((response) => {
        dispatch("click", {
          dateID: `${monthNames[monthIndex]}_${dayNumber}_${year}`,
          selectedDayStore: dayNumber,
          dayStore: response.data.filter((item) => item.bookable),
        });
        selected = dayNumber + firstDayIndexCal - 1;
      })
      .catch((error) => {
        //console.log('error', error)
      });
  };

  const showEmptyScheduler = () => {
    selected = 0;
    dispatch("click", {
      dateID: "",
      selectedDayStore: null,
      dayStore: [],
    });
  };

  const loadVisibleMonth = async () => {
    if (!availabilityEnabled) {
      monthStore = [];
      availableStore = [];
      showEmptyScheduler();
      return;
    }

    await fetchBookingDays();

    if (!autoShowTimes) return;

    if (monthStore.length > 0) {
      await fetchBookingTimes(monthStore[0]);
    } else {
      showEmptyScheduler();
    }
  };

  const goToNextMonth = async () => {
    monthStore = [];
    if (monthIndex >= 11) {
      year += 1;
      monthIndex = 0;
    } else {
      monthIndex += 1;
    }

    console.log(monthIndex, firstDayIndex, calendarCellsQty);
    await loadVisibleMonth();
  };

  const goToPrevMonth = async () => {
    monthStore = [];
    if (monthIndex <= 0) {
      year -= 1;
      monthIndex = 11;
    } else {
      monthIndex -= 1;
    }
    await loadVisibleMonth();
  };

  const handleDatePick = async (dayNumber) => {
    if (!monthStore.includes(dayNumber)) {
      return;
    }
    await fetchBookingTimes(dayNumber);
  };
</script>

<div class="chatwith-booking-calendar">
  {#if showQuantitySummary && quantity !== undefined}
    <BookingQuantitySummary {quantity} label={bookingConfig?.attendeesLabel} on:change={() => dispatch("changeQuantity")} />
  {/if}
  <div class="chatwith-booking-calendar-title">{data.translateSelectDateAndField ?? "Select a date and time"}</div>
  {#if fetchMonthsCount === 0}
    <div class="month">
      <ul>
        <li class="month-text">{month + " " + year}</li>
        <li class="prev" on:click={goToPrevMonth}>&#10094;</li>
        <li class="next" on:click={goToNextMonth}>&#10095;</li>
      </ul>
    </div>

    <ul class="weekdays">
      {#each daysList as item}
        <li>{item}</li>
      {/each}
    </ul>

    <ul class="days">
      {#each Array(calendarCellsQty) as _, i}
        {#if i + 1 < firstDayIndexCal || i + 1 >= numberOfDays + firstDayIndexCal}
          <li>&nbsp;</li>
        {:else if i + 1 === today.dayNumber + (firstDayIndexCal - 1) && monthIndex === today.month && year === today.year}
          <li
            class="today-point"
            class:active={monthStore.includes(i + 1 - firstDayIndexCal + 1)}
            class:selected={i + 1 === selected}
            class:last-booking-day={monthStore.includes(i + 1 - firstDayIndexCal + 1) &&
              availableStore[monthStore.indexOf(i + 1 - firstDayIndexCal + 1)] <= 2}
            on:click={() => handleDatePick(i + 1 - firstDayIndexCal + 1)}
          >
            <span>{i + 1 - firstDayIndexCal + 1}</span>
            <div />
          </li>
        {:else}
          <li
            class:active={monthStore.includes(i + 1 - firstDayIndexCal + 1)}
            class:selected={i + 1 === selected}
            class:last-booking-day={monthStore.includes(i + 1 - firstDayIndexCal + 1) &&
              availableStore[monthStore.indexOf(i + 1 - firstDayIndexCal + 1)] <= 2}
            on:click={() => handleDatePick(i + 1 - firstDayIndexCal + 1)}
          >
            {i + 1 - firstDayIndexCal + 1}
          </li>
        {/if}
      {/each}
    </ul>

    <div class="calendar-legend">
      <div class="calendar-legend-bullet" />
      <div class="calendar-legend-text">{translations.last_places_available[currentLang]}</div>
    </div>
  {:else}
    <div class="skeleton-calendar">
      <div class="month">
        <ul>
          <li class="month-box" />
          <li class="prev" on:click={goToPrevMonth}>&#10094;</li>
          <li class="next" on:click={goToNextMonth}>&#10095;</li>
        </ul>
      </div>

      <ul class="weekdays">
        {#each daysList as item}
          <li>{item}</li>
        {/each}
      </ul>

      <ul class="days">
        {#each Array(30) as _, i}
          <li>
            {i + 1}
          </li>
        {/each}
      </ul>
    </div>
  {/if}
</div>
